var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5C9.65685 11.5 11 10.1569 11 8.5C11 6.84315 9.65685 5.5 8 5.5C6.34315 5.5 5 6.84315 5 8.5C5 10.1569 6.34315 11.5 8 11.5Z",
    stroke: "#101828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4809 4.56873C11.6392 4.71456 11.7892 4.86456 11.9309 5.01873L13.6371 5.26248C13.9151 5.74529 14.1294 6.26209 14.2746 6.79998L13.2371 8.18123C13.2371 8.18123 13.2559 8.60623 13.2371 8.81873L14.2746 10.2C14.1301 10.7381 13.9158 11.255 13.6371 11.7375L11.9309 11.9812C11.9309 11.9812 11.6371 12.2875 11.4809 12.4312L11.2371 14.1375C10.7543 14.4155 10.2375 14.6298 9.69961 14.775L8.31836 13.7375C8.10627 13.7562 7.89295 13.7562 7.68086 13.7375L6.29961 14.775C5.7615 14.6304 5.24461 14.4161 4.76211 14.1375L4.51836 12.4312C4.36419 12.2854 4.21419 12.1354 4.06836 11.9812L2.36211 11.7375C2.0841 11.2547 1.86981 10.7379 1.72461 10.2L2.76211 8.81873C2.76211 8.81873 2.74336 8.39373 2.76211 8.18123L1.72461 6.79998C1.86914 6.26186 2.08346 5.74498 2.36211 5.26248L4.06836 5.01873C4.21419 4.86456 4.36419 4.71456 4.51836 4.56873L4.76211 2.86248C5.24493 2.58446 5.76173 2.37018 6.29961 2.22498L7.68086 3.26248C7.89295 3.24372 8.10627 3.24372 8.31836 3.26248L9.69961 2.22498C10.2377 2.36951 10.7546 2.58383 11.2371 2.86248L11.4809 4.56873Z",
    stroke: "#101828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.fe85c6b630e3c1c2b036762053979ba3.svg";
export { ForwardRef as ReactComponent };